var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuSingleNftIcon = function SvgMenuSingleNftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108548",
    d: "M0 3.624A3.624 3.624 0 0 1 3.624 0h14.5a3.624 3.624 0 0 1 3.624 3.624v14.5a3.624 3.624 0 0 1-3.624 3.624h-14.5A3.624 3.624 0 0 1 0 18.12Zm3.624-1.208a1.208 1.208 0 0 0-1.208 1.208v14.5a1.208 1.208 0 0 0 1.208 1.208h14.5a1.208 1.208 0 0 0 1.208-1.208v-14.5a1.208 1.208 0 0 0-1.208-1.208Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108549",
    d: "M7.144 8.455a2.416 2.416 0 0 0-3.417 0L.353 11.829a1.208 1.208 0 0 0 1.708 1.708l3.374-3.374 5.186 5.186a1.208 1.208 0 0 0 1.708 0l2.3-2.3 5.209 3.647a1.208 1.208 0 1 0 1.385-1.979l-5.21-3.647a2.416 2.416 0 0 0-3.094.271L11.47 12.79Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108550",
    d: "M13.892 8.456a1.812 1.812 0 1 0-1.812-1.812 1.812 1.812 0 0 0 1.812 1.812Z",
    fillRule: "evenodd"
  })));
};
export default SvgMenuSingleNftIcon;